import script from "./VersionCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionCheck.vue?vue&type=script&setup=true&lang=js"

import "./VersionCheck.vue?vue&type=style&index=0&id=93763800&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93763800"]])

export default __exports__